// import React, { useState } from 'react';
// import upArrow from '../assets/images/uparrow.svg';
// import downArrow from '../assets/images/downarrow.svg';

// const faqs = [
//   {
//     question: 'How do service credits work?',
//     answer: `Lorem ipsum dolor sit amet, consectetuer adipiscing elit. Aenean commodo ligula eget dolor. Aenean massa. Cum sociis natoque penatibus et magnis dis parturient montes, nascetur ridiculus mus. Donec quam felis, ultricies nec, pellentesque eu, pretium quis, sem. Nulla consequat massa quis enim.`,
//   },
//   {
//     question: 'What is the validity of credits?',
//     answer: `Lorem ipsum dolor sit amet, consectetuer adipiscing elit. Aenean commodo ligula eget dolor. Aenean massa. Cum sociis natoque penatibus et magnis dis parturient montes, nascetur ridiculus mus. Donec quam felis, ultricies nec, pellentesque eu, pretium quis, sem. Nulla consequat massa quis enim.`,
//   },
//   {
//     question: 'Can I transfer my credits to someone else?',
//     answer: `Lorem ipsum dolor sit amet, consectetuer adipiscing elit. Aenean commodo ligula eget dolor. Aenean massa. Cum sociis natoque penatibus et magnis dis parturient montes, nascetur ridiculus mus. Donec quam felis, ultricies nec, pellentesque eu, pretium quis, sem. Nulla consequat massa quis enim.`,
//   },
//   {
//     question: 'How do I request a service?',
//     answer: `Lorem ipsum dolor sit amet, consectetuer adipiscing elit. Aenean commodo ligula eget dolor. Aenean massa. Cum sociis natoque penatibus et magnis dis parturient montes, nascetur ridiculus mus. Donec quam felis, ultricies nec, pellentesque eu, pretium quis, sem. Nulla consequat massa quis enim.`,
//   },
// ];

// const FAQSection = () => {
//   const [activeIndex, setActiveIndex] = useState(null);

//   const toggleFAQ = (index) => {
//     setActiveIndex(prev => (prev === index ? null : index));
//   };

//   return (
//     <section className="FAQ">
//       <div className="frequently-asked">
//         <div className="frame">
//           <div className="title-section">
//             <div className="text-wrapper">Frequently Asked Questions</div>
//             <p className="div">
//               Find answers to common questions about our property maintenance services.
//             </p>
//           </div>

//           <div className="faq">
//             {faqs.map((faq, index) => {
//               const isOpen = index === activeIndex;
//               return (
//                 <div key={index} className="faq-set" onClick={() => toggleFAQ(index)}>
//                   <div className="cards">
//                     <p className="p">{faq.question}</p>
//                     <img
//                       className="down"
//                       src={isOpen ? upArrow : downArrow}
//                       alt={isOpen ? 'Collapse' : 'Expand'}
//                     />
//                   </div>
//                   {isOpen && (
//                     <p className="ipsum-deserunt">{faq.answer}</p>
//                   )}
//                 </div>
//               );
//             })}
//           </div>
//         </div>
//       </div>
//     </section>
//   );
// };

// export default FAQSection;
import React, { useState } from 'react';
import '../assets/styles/FAQSection.css';


const faqs = [
  {
    question: '💳 How do service credits work?',
    answer: (
      <div>
        <p className="mb-3">Service credits are a convenient, prepaid way to pay for our property maintenance services:</p>
        <ul className="list-unstyled ms-3">
          <li className="mb-2">✅ <strong>Purchase a plan</strong> and receive credits based on your selected tier</li>
          <li className="mb-2">🔧 <strong>Redeem credits</strong> for services like plumbing, electrical, carpentry, and more</li>
          <li className="mb-2">💯 <strong>Flexible usage</strong> - each service has a specific credit value</li>
          <li className="mb-2">⚡ <strong>Instant access</strong> to professional home maintenance whenever you need it</li>
        </ul>
      </div>
    ),
  },
  {
    question: '⏰ What is the validity of credits?',
    answer: (
      <div>
        <p className="mb-3">Your service credits come with generous validity terms:</p>
        <ul className="list-unstyled ms-3">
          <li className="mb-2">📅 <strong>12-month validity</strong> from the date of purchase</li>
          <li className="mb-2">🗓️ <strong>Ample time</strong> to use credits for any maintenance needs throughout the year</li>
          <li className="mb-2">📋 <strong>Smart planning</strong> - schedule your maintenance to maximize credit usage</li>
          <li className="mb-2">⚠️ <strong>Expiration policy</strong> - unused credits expire at the end of the validity period</li>
        </ul>
      </div>
    ),
  },
  {
    question: '🔄 Can I transfer my credits to someone else?',
    answer: (
      <div>
        <p className="mb-3"><strong>No, service credits are non-transferable.</strong> Here's what you need to know:</p>
        <ul className="list-unstyled ms-3">
          <li className="mb-2">🔒 <strong>Account-specific</strong> - credits are tied to the purchaser's account</li>
          <li className="mb-2">🛡️ <strong>Security first</strong> - this policy ensures account security and accurate records</li>
          <li className="mb-2">🏠 <strong>Multiple properties</strong> - you CAN use credits for any property you own or manage</li>
          <li className="mb-2">📍 <strong>Service area</strong> - applies to properties within our coverage zone</li>
        </ul>
      </div>
    ),
  },
  {
    question: '📞 How do I request a service?',
    answer: (
      <div>
        <p className="mb-3">Requesting a service is simple and convenient! Choose your preferred method:</p>
        <ul className="list-unstyled ms-3">
          <li className="mb-2">📱 <strong>Mobile App</strong> - Quick and easy booking on the go</li>
          <li className="mb-2">🌐 <strong>Website</strong> - Submit a request online anytime</li>
          <li className="mb-2">☎️ <strong>Phone</strong> - Call our customer service team directly</li>
        </ul>
        <p className="mt-3 mb-2"><strong>The process:</strong></p>
        <ul className="list-unstyled ms-3">
          <li className="mb-2">1️⃣ Describe your maintenance issue</li>
          <li className="mb-2">2️⃣ We match you with a qualified professional</li>
          <li className="mb-2">3️⃣ Schedule a visit at your preferred time</li>
          <li className="mb-2">4️⃣ Credits are deducted automatically upon service completion</li>
        </ul>
      </div>
    ),
  },
];

const FAQSection = () => {
  const [activeIndex, setActiveIndex] = useState(null);

  const toggleFAQ = (index) => {
    setActiveIndex(prev => (prev === index ? null : index));
  };

  return (
    <section className="py-5" id="faqsection">
      <div className="container" style={{ maxWidth: '1400px' }}>
        <div className="faq-wrapper">
          <div className="text-center mb-5">
          <h2 className="fw-bold display-6">❓ Frequently Asked Questions</h2>
          <p className="text-secondary">
            Find answers to common questions about our property maintenance services.
          </p>
        </div>

        <div className="accordion" id="faqAccordion" style={{ maxWidth: '900px', margin: '0 auto' }}>
          {faqs.map((faq, index) => {
            const isOpen = index === activeIndex;
            const headingId = `heading-${index}`;
            const collapseId = `collapse-${index}`;

            return (
              <div className="accordion-item mb-3 border-0" key={index}>
                <h2 className="accordion-header" id={headingId}>
                  <button
                    className={`accordion-button d-flex justify-content-between align-items-center ${!isOpen ? 'collapsed' : ''}`}
                    type="button"
                    onClick={() => toggleFAQ(index)}
                    aria-expanded={isOpen}
                    aria-controls={collapseId}
                  >
                    <span className="me-2 fw-medium">{faq.question}</span>
                  </button>
                </h2>
                <div
                  id={collapseId}
                  className={`accordion-collapse collapse ${isOpen ? 'show' : ''}`}
                  aria-labelledby={headingId}
                >
                  <div className="accordion-body text-secondary">
                    {faq.answer}
                  </div>
                </div>
              </div>
            );
          })}
        </div>
        </div>
      </div>
    </section>
  );
};

export default FAQSection;
